export const registerSplitListPartials = () => {
    const {Handlebars: handleBars} = window;
    handleBars.registerPartial("matches-list", $("#matches-list-template").html());
    handleBars.registerPartial("responses-list", $("#responses-list-template").html());
    handleBars.registerPartial("matches-closed-partial", $("#matches-closed-request-template").html());
}

export const registerHBPartials = (partials) => {
    const {Handlebars: handleBars} = window;
    if (!partials.length) {
        return;
    }

    try {
        for (let i = 0; i < partials.length; i++) {
            let partialId = partials[i];
            handleBars.registerPartial(partialId, $("#" + partialId).html());
        }
    } catch (err) {
        bugsnagClient && bugsnagClient.notify(new Error('Error registering partial'), {
            metaData: { error: err }
        });
    }

}
